export default __webpack_public_path__ + "static/media/stuart-marshall-2017-contributions.d60a0ed1.png";